// extracted by mini-css-extract-plugin
module.exports = {"list":"ServiceList_list__382I-"};